import {useContext} from 'react'
import axios from 'axios';
import { QlikUIContext } from '../../QlikUIContext'

export function useReportsQlikApi() {

    const context = useContext(QlikUIContext);

    const AxiosInstance = axios.create({
        timeout: 30000
      });
    
    AxiosInstance.defaults.validateStatus = (status) => {
        return (status >= 200 && status < 300) || status === 498;
    };
      
    AxiosInstance.interceptors.request.use(
        config => {
            config.headers['Ocp-Apim-Subscription-Key'] = context.subscription 
            config.headers['Authorization'] = `Bearer ` + context.securityToken
            config.headers['Content-type'] = 'application/json' 
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );
    
    AxiosInstance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.code === 'ECONNABORTED') {
                // TODO: i18n
                console.log('Se ha perdido la conexion con el servidor (timeout)');
            } else if (error.response?.status === 412) {
            // Rulebook errors
                console.log('ERROR 412', error.response);
    
                return Promise.reject({
                    statusCode: error.response.status,
                    errors: error.response.data.value.map(x => x.errorCode)
                });
            } else {
                console.log('ERROR interceptor', error.response, {
                    statusCode: error.response?.status,
                    errors: [error.response ? error.response.statusText : '']
                });
    
                return Promise.reject({
                    statusCode: error.response?.status,
                    errors: null
                });
            }
            return Promise.reject(error);
        }
    );

    const GetReport = async (userName, reportName, reportType) => {
        return await AxiosInstance.post(
            `${context.reportsQlikApiEndpoint}/Report/Get`,
            {
                UserName: userName,
                FileName: reportName,
                ReportType: reportType
            }
            )
            .then(response => {
                return response.data;
            })
            .catch(() => {
                return null;
            });
    };

    const GetWidgetActions = async () => {
        return await AxiosInstance.get(
            `${context.reportsQlikApiEndpoint}/WidgetActions/List`
        ).then(response => {
            return response.data;
        })
        .catch(()=> {
            return null;
        });
    };

    async function GetReports(userName, roles, reportType) {
        return await AxiosInstance.post(
            `${context.reportsQlikApiEndpoint}/Report/List`,
            {
                UserName: userName,
                Roles: roles,
                ReportType: reportType
            }
            )
            .then(response => {
                return response.data;
            })
            .catch(() => {
                return null;
            });      
    };
    
    const GetAmbits = async (reportType, roles) => {
        return await AxiosInstance.post(
            `${context.reportsQlikApiEndpoint}/Ambits/ListByReportType`,
            {
                ReportType: reportType,
                Roles: roles
            }
            )
            .then(response => {
                return response.data;
            })
            .catch(() => {
                return null;
            });
    }

    const GetAllAmbits = async () => {
        return await AxiosInstance.get(
            `${context.reportsQlikApiEndpoint}/Ambits/List`
            )
            .then(response => {
                return response.data;
            })
            .catch(() => {
                return null;
            });   
    };

    const SaveAmbits = async (ambits) => {
        return await AxiosInstance.post(
            `${context.reportsQlikApiEndpoint}/Ambits/SaveList`,
            JSON.stringify(ambits)
            )
            .then(response => {
                return response.data;
            })
            .catch(() => {
                return null;
            }); 
    };
    
    const SaveQlikWidgets = async (qlikWidgets) => {
        return await AxiosInstance.post(
            `${context.reportsQlikApiEndpoint}/QlikWidgets/SaveList`,
            JSON.stringify(qlikWidgets)
            )
            .then(response => {
                return response.data;
            })
            .catch(() => {
                return null;
            }); 
    };

    const DeleteReport = async (userName, fileName, reportType) => {
        return await AxiosInstance.post(
            `${context.reportsQlikApiEndpoint}/Report/Delete`,
            {
            UserName: userName,
            FileName: fileName,
            ReportType: reportType
            }
        )
        .then(response => {
            return response.data;
        })
        .catch(() => {
            return null;
        });      
    };

    return {GetReport, GetWidgetActions, GetReports, GetAllAmbits, SaveAmbits, SaveQlikWidgets, DeleteReport, GetAmbits };
}